import { marked } from 'marked';
import DOMPurify from 'dompurify';
import './markdown.css';

marked.setOptions({ breaks: true, gfm: true });

export function renderMarkdown(text) {
  if (!text) return '';

  const downloads = [];
  const preprocessed = String(text).replace(
    /\[([^\]]*)\]\(sandbox:\/mnt\/data\/([^)]+)\)/g,
    (_, label, filename) => {
      const idx = downloads.length;
      downloads.push({ label: label || filename, filename });
      return `@@DLPH_${idx}@@`;
    }
  );

  const rawHtml = marked.parse(preprocessed);
  let safeHtml = DOMPurify.sanitize(rawHtml, { ADD_ATTR: ['target'] });

  safeHtml = safeHtml.replace(/>\n+\s*</g, '><');

  safeHtml = safeHtml.replace(
    /<table(\s[^>]*)?>([\s\S]*?)<\/table>/g,
    '<div class="rcw-md-table-wrapper"><table$1>$2</table></div>'
  );

  safeHtml = safeHtml.replace(/@@DLPH_(\d+)@@/g, (_, idx) => {
    const dl = downloads[parseInt(idx, 10)];
    if (!dl) return '';
    const fname = String(dl.filename).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
    const lbl = String(dl.label)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    return `<a href="#" style="color: blue; text-decoration: underline;" onclick="downloadFile('${fname}')">${lbl}</a>`;
  });

  return safeHtml;
}
